module.exports = __webpack_public_path__ + "9fed961f378e16a20e99092b1848dc57.png";